<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="bigTotal"
            :label="'Contact'">
      <router-link slot="dropdown-content" :to="{name: 'ContactCreate'}"
                    class="dropdown-item">
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Créer contact</span>
      </router-link>
      <router-link slot="dropdown-content" :to="{name: 'DenunciationList'}"
                    class="dropdown-item">
        <span>Afficher dénonciations</span>
        <span class="tag is-notification">{{runningDenunciations.length}}</span>
      </router-link>
      <router-link v-if="isAdmin"
        slot="dropdown-content" :to="{name: 'OriginList'}"
        class="dropdown-item">
        <span>Origines contact</span>
      </router-link>
      <router-link v-if="!isSectorManager"
        slot="dropdown-content" :to="{name: 'LeadList'}"
        class="dropdown-item">
        <span>Leads</span>
      </router-link>
      <a @click="exportXls('contacts-export', query)" class="dropdown-item" slot="dropdown-content" v-if="(isAdmin || isSectorManager) && !multiselection">
        <span class="icon"><i class="fas fa-file-export"></i></span>
        <span>Exporter données .XLS</span>
      </a>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
         id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetAllFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     :more-filters-label="'Critères supplémentaires'"
                     @opened="opened = !opened">
          <div class="columns" v-if="isAdmin || isManager || isSectorManager">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @input="val => updateKeyFilter(val, 'seller')"
                             v-model="filters.seller" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :multiple="true" :close-on-select="false"
                             :options="sellers" :searchable="true" :show-labels="false"
                             :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
                             :placeholder="''"
                             @search-change="getSellers">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="sellers.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="placeholder" class="multiselect__placeholder">Référent(s)</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Référent(s) ({{values.length}})</span>
                  </span>
                  <span slot="noResult">Oups! Aucun référent trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @input="val => updateKeyFilter(val, 'company')"
                             v-model="filters.company" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="companies" :searchable="true"
                             :show-labels="false" :placeholder="''"
                             @search-change="getCompanies">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="companies.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                  <span slot="noResult">Oups! Aucune société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="val => updateKeyFilter(val, 'origin_type')" @remove="updateKeyFilter(null, 'origin_type')"
                             v-model="filters.origin_type" label="label"
                             track-by="value" :placeholder="''"
                             :options="originTypeList" :searchable="false" :show-labels="false">
                  <span slot="placeholder" class="multiselect__placeholder">Source</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-small">
              <div class="control">
                <multiselect v-model="filters.origin" track-by="pk"
                             @input="val => updateKeyFilter(val, 'origin')"
                             class="multiselect--option-ico"
                             :custom-label="val => limitText(val.name)"
                             :value="filters.origin_name" :close-on-select="false"
                             group-values="children" group-label="name" :group-select="true" :multiple="true"
                             :options="originGroups" :searchable="true" :show-labels="false"
                             @search-change="getOrigins" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="origins.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucune origine trouvée.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Origine(s)</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Origine(s) ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-top is-padding-bottom-small">
              <div class="field has-addons">
                <div class="control">
                  <a
                          class="button is-square is-static is-border is-min-width-0 is-padding-left-xsmall is-padding-right-xsmall">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" v-model="range_date"
                              class="input is-padding-left-xsmall is-paddingless-right" name="date"
                              placeholder="Date de création"
                              @on-change="updateDateFilter">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a
                          class="button is-square is-grey is-inverted is-border is-min-width-0 is-padding-left-small is-padding-right-small"
                          @click="range_date = null">
                    <span class="icon"><i class="fas fa-times"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <input @input="inputChange" v-model="filters.last_name" class="input" type="text" placeholder="Nom / Prénom">
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <input @input="inputChange" v-model="filters.email" class="input" type="text" placeholder="Email">
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @input="val => updateKeyFilter(val, 'csp')"
                             v-model="filters.csp" label="label"
                             track-by="value" :placeholder="''"
                             :multiple="true"
                             :options="contactCspList" :searchable="false" :close-on-select="false" :show-labels="false">
                  <span slot="placeholder" class="multiselect__placeholder">CSP</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>CSP ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @input="val => updateKeyFilter(val, 'family_situation')"
                             v-model="filters.family_situation" label="label"
                             track-by="value" :placeholder="''"
                             :multiple="true" :close-on-select="false" :show-labels="false"
                             :options="familySituationList" :searchable="false">
                  <span slot="placeholder" class="multiselect__placeholder">Situation familiale</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Statut familiale ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @input="val => updateKeyFilter(val, 'matrimonial_status')"
                             v-model="filters.matrimonial_status" label="short_label"
                             track-by="value" :placeholder="''"
                             :multiple="true" :close-on-select="false" :show-labels="false"
                             :options="matrimonalStatusList" :searchable="false">
                  <span slot="placeholder" class="multiselect__placeholder">Statut matrimonial</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Statut matrimonial ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-filters">
            <div class="column is-padding-top-small">
              <range-chooser :formatter="(value) => `${value / 1000} k`" @change="updateIncomeFilter"
                             :re-render="opened"
                             :max="150000"
                             :custom-labels="['0', '50', '100', '150']"
                             :label="`Revenu annuel en ${currency}`"
                             :is-slider="true"
                             :step="10000" :model="[filters.income__gte, filters.income__lte]"></range-chooser>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd is-overflow-auto" :class="{'is-12':(isSeller && isExternal)}">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} contact(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow is-border-left"
              v-if="multiselection && selectedItems.length">
              <a @click="exportContacts" class="page-header-btn is-small">
                <span class="icon"><i class="fas fa-file-export"></i></span>
                <span>Exporter données contacts</span>
              </a>
            </div>
            <div class="column is-narrow is-border-left"
              v-if="multiselection && selectedItems.length">
              <a @click="addSeller" class="page-header-btn is-small">
                <span class="icon"><i class="fas fa-user-tag"></i></span>
                <span>Changer l'utilisateur référent ({{selectedItems.length}})</span>
              </a>
            </div>
            <div class="column is-narrow is-border-left" v-if="!multiselection">
              <a @click="multiselection = !multiselection" data-tooltip="Sélection multiple"
                          class="page-header-btn is-small is-square tooltip is-tooltip-left is-tooltip-primary">
                <span class="icon"><i class="fas fa-tasks"></i></span>
              </a>
            </div>
            <div class="column is-narrow is-border-left" v-if="multiselection">
              <a @click="cancelMultiselect" class="page-header-btn is-small is-info is-square tooltip is-tooltip-left is-tooltip-primary" data-tooltip="Annuler la sélection">
                <span class="icon"><i class="fas fa-tasks has-text-white"></i></span>
              </a>
            </div>
          </div>
          <div class="is-padding" v-if="hasFilter && !loading">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.seller"
                    v-for="(seller, i) in filters.seller" :key="'seller-' + i">
                {{seller.last_name}} {{seller.first_name}} <a @click="deleteFilter(i, 'seller')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.company">
                {{filters.company.name}} <a @click="updateKeyFilter(null, 'company')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.origin_type">
                {{filters.origin_type.label}} <a @click="updateKeyFilter(null, 'origin_type')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.origin"
                    v-for="(origin, i) in filters.origin" :key="'pole-' + i">
                {{origin.name}} <a @click="deleteFilter(i, 'origin')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.last_name">
                {{filters.last_name}} <a @click="deleteFilterSimple(last_name)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.email">
                {{filters.email}} <a @click="deleteFilterSimple(email)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.csp"
                    v-for="(csp, i) in filters.csp" :key="'csp-' + i">
                {{csp.label}} <a @click="deleteFilter(i, 'csp')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="range_date">
                {{range_date}} <a @click="range_date = null"
                                                  class="icon is-white is-margin-left-xsmall"><i
                      class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.family_situation"
                    v-for="(family_situation, i) in filters.family_situation" :key="'family_situation-' + i">
                {{family_situation.label}} <a @click="deleteFilter(i, 'family_situation')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.matrimonial_status"
                    v-for="(matrimonial_status, i) in filters.matrimonial_status" :key="'matrimonial_status-' + i">
                {{matrimonial_status.label}} <a @click="deleteFilter(i, 'matrimonial_status')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.income__gte">
                &gt; {{filters.income__gte}} <a @click="deleteFilterSimple('income__gte')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.income__lte">
                &lt; {{filters.income__lte}} <a @click="deleteFilterSimple('income__lte')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetAllFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length" v-if="!loading">
            <table v-show="!loading && items.length"
                  class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                  <button v-if="multiselection" class="button is-small is-light is-circle" @click="selectItemToggleAll(items)">
                    <i class="far fa-check-double"></i>
                  </button>
                  <div v-else
                    class="dropdown is-hoverable is-left">
                    <div class="dropdown-trigger">
                      <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                        <i class="fal fa-cog"></i>
                      </button>
                    </div>
                    <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                  </div>
                </th>
                <th class="is-groupcols-1a">
                  <sortable @sort="sort('last_name', $event)" :sort="sortBy.last_name" label="Nom"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a">
                  <sortable @sort="sort('first_name', $event)" :sort="sortBy.first_name" label="Prénom"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('email')">
                  <sortable @sort="sort('email', $event)" :sort="sortBy.email" label="Email"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('phone')">
                  Téléphone/Mobile
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('address__zip_code')">
                  <sortable @sort="sort('address__zip_code', $event)" :sort="sortBy.zip_code" label="Ville"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('type')">
                  <sortable @sort="sort('origin_type', $event)" :sort="sortBy.origin_type"
                            label="Source"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('origin')">
                  <sortable @sort="sort('origin_name', $event)" :sort="sortBy.origin_name" label="Origine"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="(isAdmin || isManager || isSectorManager) && showColumn('seller')">
                  <sortable @sort="sort('seller_name', $event)" :sort="sortBy.seller_name" label="Dénonciation"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('company') && (isAdmin || isSectorManager)">
                  <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name" label="Société"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a" v-if="showColumn('created_on')">
                  <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on" label="Date"></sortable>
                  <div class="deco"></div>
                </th>
                <th class="is-groupcols-1a has-text-centered"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(c, index) in items" :key="c.pk" class="is-size-6" :id="'e' + c.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === c.pk}">
                <td class="is-cell-hoverable is-paddingless has-text-centered actions">
                  <router-link v-if="!multiselection" :to="{name: 'ContactVue', params: {id: c.pk}, query: {returnId: c.pk, page: currentPage}}">
                    <avatar :item="c" :i="index"></avatar>
                  </router-link>
                  <multiselect-button v-else
                                      :data="c"
                                      :is-checked="checkedItem(c.pk)"
                                      :multiselection="multiselection"
                                      @selected="selectItem">
                  </multiselect-button>
                </td>
                <td class="is-cell-hoverable">
                  <router-link class="is-cell-hoverable" :to="{name: 'ContactVue', params: {id: c.pk}, query: {returnId: c.pk, page: currentPage}}">
                    {{c.last_name}}
                  </router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link class="is-cell-hoverable" :to="{name: 'ContactVue', params: {id: c.pk}, query: {returnId: c.pk, page: currentPage}}">
                    {{c.first_name}}
                  </router-link>
                </td>
                <td v-if="showColumn('email')" :class="{'is-cell-hoverable': c.email}" >
                  <router-link v-if="c.email" :to="{name: 'ContactVue', params: {id: c.pk}, query: {returnId: c.pk, page: currentPage}}"
                    :title="c.email">
                    {{c.email | truncate(35)}}
                  </router-link>
                </td>
                <td v-if="showColumn('phone')">
                  <span v-if="c.mobile">{{c.mobile}}</span>
                  <span v-else-if="c.phone">{{c.phone}}</span>
                  <span v-else>N.C</span>
                </td>
                <td v-if="showColumn('address__zip_code')" class="">
                  {{c.address.city || '-'}} <span v-if="c.address.zip_code">({{c.address.zip_code}})</span>
                </td>
                <td v-if="showColumn('type')">
                  <span class="tag has-text-light" :style="{'background-color': tagColor(c.origin_type)}" v-if="c.origin_type">
                    {{c.origin_type | originTypeLabel}}</span>
                  <span v-else>-</span>
                </td>
                <td v-if="showColumn('origin')" class="is-narrow">
                  <span :title="c.origin_name">{{(c.origin_name || '-') | truncate}}</span>
                </td>
                <td v-if="(isAdmin || isManager || isSectorManager) && showColumn('seller')" class="is-cell-hoverable is-narrow">
                  <router-link v-if="c.seller" :to="{name: 'UserVue', params: {id: c.seller}, query: {returnId: c.pk, page: currentPage}}">
                    {{c.seller_name}}
                  </router-link>
                  <span v-else>-</span>
                </td>
                <td v-if="showColumn('company') && (isAdmin || isSectorManager)">
                  <span :title="c.company_name">{{(c.company_name || '-') | truncate}}</span>
                </td>
                <td v-if="showColumn('created_on')" class="is-narrow">
                  {{c.created_on | dateTime}}
                </td>
                <td class="has-text-centered actions">
                  <display-button-list :forceDropDown="true" :buttons="buttonList" :data="c"
                                       :openUp="{'position': index, 'total': items.length}">
                  </display-button-list>
                </td>
              </tr>
              <tr class="empty empty--row" v-for="n in items.length < 5 ? 5 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
          </table-h-scroll>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
            <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
          </div>
          <div v-show="!loading && !items.length">
            <div class="columns">
              <div class="column">
                <h2 class="title is-3 has-text-weight-bold">Aucun contact disponible</h2>
                <a class="has-text-primary" @click="resetAllFilters" v-if="hasFilter"><span class="icon is-small"><i
                  class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Error, GenericList, Sort, Filter, ColumnConf, DefaultValues, MultiSelection, TableHeaderSticky } from '../../mixins'
  import { mapState, mapGetters } from 'vuex'
  import { exportXls, downloadURI } from '../../utils'
  import { debounce, isPlainObject } from 'lodash'
  import randomColor from 'randomcolor'
  import moment from 'moment'

  export default {
    name: 'ContactList',
    mixins: [Error, GenericList, Sort, Filter, ColumnConf, DefaultValues, MultiSelection, TableHeaderSticky],
    data () {
      return {
        range_date: null,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        multipleBuyer: true,
        columnsConfResource: 'contact',
        buttonList: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'ContactVue', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-address-card',
            text: 'Fiche contact'
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'ContactEdit', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-user-edit',
            text: 'Modifier fiche'
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer contact'
          }
        ],
        companies: [],
        sellers: [],
        opened: true,
        service: this.$api.contactService,
        loadDocuments: this.loadItems,
        origins: [],
        exportXls,
        filters: {
          created_on__gte: null,
          created_on__lte: null,
          csp: null,
          family_situation: null,
          matrimonial_status: null,
          origin: [],
          seller: []
        },
        initFilters: {
          created_on__gte: null,
          created_on__lte: null,
          csp: null,
          family_situation: null,
          matrimonial_status: null,
          origin: [],
          seller: []
        },
        enableSaveQuery: true,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        currentUser: 'currentUser',
        quickview: 'quickview',
        scrollToEl: 'scrollToEl',
        scrollToPage: 'scrollToPage',
        runningDenunciations: 'runningDenunciations',
        originsList: 'origins',
        companiesList: 'companies'
      }),
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'isExternal', 'isSeller', 'originGroups']),
      columnsShow () {
        const columns = {
          'email': {label: 'Email', mobile: true},
          'phone': {label: 'Téléphone/Mobile', mobile: false},
          'address__zip_code': {label: 'Ville', mobile: false}
        }
        if (!this.isExternal) {
          columns.type = {label: 'Source', mobile: false}
          columns.origin = {label: 'Origine', mobile: false}
        }
        if (this.isAdmin || this.isSectorManager) {
          columns.seller = {label: 'Dénonciation', mobile: true}
          columns.company = {label: 'Société', mobile: true}
        }
        columns.created_on = {label: 'Date', mobile: false}
        return columns
      },
      currency () {
        return this.$currency
      }
    },
    filters: {
      dateTime (v) {
        return moment(v).format('DD/MM/YY')
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            let contacts = this.items.filter(x => this.selectedItems.includes(x.pk))
            contacts.forEach((x, i) => {
              x.seller = results.entities[0].pk
              this.$api.contactService.put(x.pk, x).then(r => {
                Object.assign(x, r.data)
                if (i === contacts.length - 1) {
                  this.$notify({
                    type: 'is-success',
                    text: 'Un nouveau vendeur à été ajouté au(x) contact(s)'
                  })
                }
              })
            })
            this.multiselection = !this.multiselection
            this.clearSelectedItems()
          } else if (mode === 'NEW_CONTACT') {
            this.$api.contactService.post(results.contact).then(r => {
              this.items.unshift(r.data)
              this.$notify({
                type: 'is-success',
                text: 'Nouveau contact ajouté'
              })
            })
          }
        }
      }
    },
    methods: {
      resetAllFilters (e) {
        this.range_date = null
        this.$nextTick(() => {
          this.resetFilters()
        })
      },
      updateDateFilter: debounce(function (e) {
        console.log(e)
        if (e.length === 2 && (e[0] !== this.filters['created_on__gte'] || e[1] !== this.filters['created_on__lte'])) {
          this.$set(this.filters, 'created_on__gte', moment(e[0]).format('DD/MM/YYYY'))
          this.$set(this.filters, 'created_on__lte', moment(e[1]).format('DD/MM/YYYY'))
          this.$nextTick(() => {
            this.changeFilters()
          })
        } else if (e.length === 0) {
          this.filters.created_on__gte = null
          this.filters.created_on__lte = null
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      deleteFilterSimplte (key) {
        this.$set(this.filters, key, null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      limitText (text) {
        if (text.length > 20) {
          return text.substring(0, 20) + '...'
        } else return text
      },
      tagColor (value) {
        let color = randomColor({
          seed: value,
          hue: 'blue'
        })
        return color
      },
      errorDelete (r) {
        this.handleError(r)
      },
      updateKeyFilter (e, key) {
        this.$set(this.filters, key, e)
        if (key === 'company' && e === null) {
          delete this.filter.company
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateIncomeFilter: debounce(function (e) {
        if (e[0] !== this.filters.income__gte || e[1] !== this.filters.income__lte) {
          this.$set(this.filters, 'income__gte', e[0])
          this.$set(this.filters, 'income__lte', e[1])
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      updateAgeFilter: debounce(function (e) {
        if (e[0] !== this.filters.age__gte || e[1] !== this.filters.age__lte) {
          this.$set(this.filters, 'age__gte', e[0])
          this.$set(this.filters, 'age__lte', e[1])
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      beforeGet () {
        if (this.query.company && isPlainObject(this.query.company)) {
          this.query.company = this.query.company.pk
        }
        if (this.query.seller && isPlainObject(this.query.seller)) {
          this.query.seller = this.query.seller.pk
        }
        if (this.query.origin && isPlainObject(this.query.origin)) {
          this.query.origin = this.query.origin.pk
        }
        if (this.query.origin_type && isPlainObject(this.query.origin_type)) {
          this.query.origin_type = this.query.origin_type.value
        }
        if (Array.isArray(this.query.origin)) {
          let origins = []
          for (let origin of this.query.origin) {
            if (origin && isPlainObject(origin)) {
              origins.push(origin.pk)
            } else {
              origins.push(origin)
            }
          }
          this.query.origin = origins
        }
        if (Array.isArray(this.query.seller)) {
          let sellers = []
          for (let seller of this.query.seller) {
            if (seller && isPlainObject(seller)) {
              sellers.push(seller.pk)
            } else {
              sellers.push(seller)
            }
          }
          this.query.seller = sellers
        }
        if (Array.isArray(this.query.csp)) {
          this.query.csp = this.query.csp.map(x => x.value)
        }
        if (Array.isArray(this.query.family_situation)) {
          this.query.family_situation = this.query.family_situation.map(x => x.value)
        }
        if (Array.isArray(this.query.matrimonial_status)) {
          this.query.matrimonial_status = this.query.matrimonial_status.map(x => x.value)
        }
      },
      getCompanies () {
        this.$api.companyService.get().then(r => {
          this.companies = r.data.items
        })
      },
      getSellers (query) {
        this.$api.userService.get({last_name: query, profil_type: ['manager', 'seller', 'admin', 'operator', 'seller_ext', 'manager_ext'], sort: 'last_name:asc'}).then(r => {
          this.sellers = r.data.items
        })
      },
      getOrigins () {
        this.$api.originService.get({sort: 'name:asc'}).then(r => {
          this.origins = r.data
        })
      },
      addSeller () {
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION'})
      },
      exportContacts () {
        const apiUrl = this.$configs.APIURL
        const exportURl = `${apiUrl}/contacts-export?pk[]=${this.selectedItems.join('&pk[]=')}`
        downloadURI(exportURl, 'Export-contacts.xlsx')
      },
      deleteFilter (i, key) {
        this.filters[key].splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      }
    },
    async created () {
      if (this.currentUser && this.currentUser.is_admin) this.companies = this.companiesList.slice()
      if (this.$route.query) {
        Object.assign(this.filters, this.$route.query)
        if (this.$route.query.created_on__gte && this.$route.query.created_on__lte) {
          this.range_date = this.$route.query.created_on__gte + ' au ' + this.$route.query.created_on__lte
        }
      }
      this.getSellers()
      this.origins = this.originsList.slice()
      this.query.sort = 'last_name:asc'
      await this.changeFilters()
    }
  }
</script>

<style>
  is-annonce {
    background-color: #f87051
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/ContactList.vue